import { ApiKey } from '@pubstack/common/src/site'
import { sortByName } from '@pubstack/common/src/sort'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const API_KEYS_QUERY_KEYS = ['settings', 'api-keys']
const url = `/api-keys`
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useApiKeys = () => {
  return useQuery<ApiKey[]>({
    url,
    keys: API_KEYS_QUERY_KEYS,
    select: sortByName,
  })
}
//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateApiKeys = (toasts: MutationToasts = {}) => {
  return useMutation<Omit<ApiKey, 'id' | 'scopeId'>>({
    method: 'post',
    url,
    collectionKeys: API_KEYS_QUERY_KEYS,
    ...toasts,
  })
}
